module.exports = __webpack_public_path__ + "img/album07_11.46a0b717.jpg";